import { DataClientOptions, FlexDataClient, NormalizedCacheObject } from "~/modules/dataClient";
import { Action } from "~/modules/actions/Action";
import { ContextManager, ContextInstance } from "~/modules/contextManager/ContextManager";
import { DataClientImpl } from "~/modules/dataClient/DataClientImpl";


























export class InitializeDataClient implements Action<Promise<FlexDataClient<NormalizedCacheObject> | null>> {
    readonly #options?: DataClientOptions;

    constructor(dataClientOptions?: DataClientOptions) {
        this.#options = dataClientOptions;
    }

    

 
    async run(ctx: {}): Promise<FlexDataClient<NormalizedCacheObject> | null> {
        const context = ctx as ContextManager;
        const dataClient = context.retrieveInstanceOf(ContextInstance.DataClientImpl, DataClientImpl);
        await dataClient.init(this.#options);
        return dataClient.client;
    }
}
